import { Component, Input } from '@angular/core';

@Component({
  selector: 'alert',
  templateUrl: './alert.component.html'
})
export class AlertComponent {
  @Input() header: string = 'Alert';
  @Input() message: string;
  @Input() okVisible: boolean = true;
  @Input() cancelVisible: boolean = false;
}
